module.exports = __webpack_public_path__ + "static/media/icon-experiment.6f8093c7.svg";